module.exports = __webpack_public_path__ + "static/media/aflW.43f5c70f.svg";